module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-34a480e9a2a1327101a574e8d76541cb.webp";